import { Input } from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
  KreFormFieldConfig,
  KreAttachmentFile,
} from "../components/kre-form.field.config";

export abstract class FieldType<
  F extends KreFormFieldConfig = KreFormFieldConfig
> {
  @Input() field: F;
  defaultOptions?: F;

  @Input()
  get model() {
    return this.field.model;
  }
  set model(m: any) {}

  @Input()
  get form() {
    return <FormGroup>this.field.parent.formControl;
  }
  set form(form) {}

  @Input()
  get options() {
    return this.field.options;
  }
  set options(options: F["options"]) {}

  get key() {
    return this.field.key;
  }
  get fontProperty() {
    return (
      this.field.fontProperty || {
        fontSize: 14,
        color: "#323232",
        fontWeight: false,
        fontStyle: false,
      }
    );
  }

  get formControl() {
    return this.field.formControl;
  }

  get to() {
    return this.field.templateOptions || {};
  }

  get showError(): boolean {
    return this.options.showError(this);
  }

  get id(): string {
    return this.field.id;
  }

  get formState() {
    return this.options.formState || {};
  }

  get formStatus() {
    return this.field.status || 0;
  }

  get editor() {
    if (this.field.hasOwnProperty("editor")) {
      return this.field.editor;
    }
    return true;
  }

  get operationProperty() {
    if (this.field.hasOwnProperty("operationProperty")) {
      return this.field.operationProperty;
    }
  }

  get text() {
    if (!!this.model && this.model!.hasOwnProperty(this.field.key)) {
      return this.model[this.field.key];
    }
    return "";
  }

  get placeHolder() {
    if (
      this.to != undefined &&
      this.to != null &&
      this.to.placeholder != undefined &&
      this.to.placeholder != null
    ) {
      return this.to.placeholder;
    }
    return "";
  }

  get textSingle() {
    let result = "";
    if (
      this.model &&
      this.model != null &&
      this.model!.hasOwnProperty(this.field.key)
    ) {
      let values = this.model[this.field.key];
      if (values && values != null && Array.isArray(values)) {
        result = values
          .map((item: any) => {
            return item.label;
          })
          .join(",");
      }
    }
    return result;
  }

  get textRadio() {
    let result = "";
    if (
      this.model &&
      this.model != null &&
      this.model!.hasOwnProperty(this.field.key)
    ) {
      let value = this.model[this.field.key];
      if (value != null && value != "") {
        if (
          this.field.templateOptions &&
          this.field.templateOptions.options &&
          this.field.templateOptions.options != null
        ) {
          this.field.templateOptions.options.forEach((item: any) => {
            if (item.value == value) {
              result = item.label;
            }
          });
        }
      }
    }

    return result;
  }

  get textMultiple() {
    let result = "";
    if (
      this.model &&
      this.model != null &&
      this.model!.hasOwnProperty(this.field.key)
    ) {
      let values = this.model[this.field.key];
      if (values && values != null && Array.isArray(values)) {
        result = values
          .map((item: any) => {
            return item.label;
          })
          .join("、");
      }
    }
    return result;
  }

  get textLookUp() {
    let result = [];
    if (
      this.model &&
      this.model != null &&
      this.model.hasOwnProperty(this.key)
    ) {
      if (
        this.model[this.key] != undefined &&
        this.model[this.key] != null &&
        this.model[this.key].length > 0
      ) {
        result = this.model[this.key].map((item: any) => {
          return item.label;
        });
      }
    }
    return result.join("、");
  }

  get tips() {
    if (
      this.to != undefined &&
      this.to != null &&
      this.to.tips != undefined &&
      this.to.tips != null
    ) {
      return this.to.tips;
    }
    return "";
  }

  get attachment() {
    let result = [];
    if (this.model!.hasOwnProperty(this.field.key)) {
      if (
        this.model[this.field.key] != null &&
        (this.model[this.field.key] as KreAttachmentFile)
      ) {
        result = this.model[this.field.key];
      }
    }
    return result;
  }

  get attachmentDisabled() {
    let result = false;
    if (this.to.hasOwnProperty("attachment")) {
      if (this.to.attachment.hasOwnProperty("limit")) {
        let limit = this.to.attachment.limit;
        if (limit != null) {
          let attachment: any = this.attachment;
          if (attachment != null) {
            result = this.attachment.length >= limit;
          }
        }
      }
    }
    return result;
  }

  get active() {
    let result = false;
    if (
      this.field["active"] != undefined &&
      this.field["active"] != null &&
      this.field["active"] == true
    ) {
      result = true;
    }
    return result;
  }

  get rowNumber() {
    let result = 0;
    if (this.field["active"] != undefined && this.field["active"] != null) {
      result = this.field.rowNumber;
    }
    return result;
  }
  get isCheckboxShow() {
    let result = true;
    if (
      this.field.design != undefined &&
      this.field.design != null &&
      Object.keys(this.field.design).length > 0
    ) {
      result = false;
    }
    return result;
  }

  isOptionChecked(value: any) {
    let result = false;
    if (this.model && this.model[this.key]) {
      result = this.model[this.key].some((item) => {
        return item.value == value;
      });
    }
    return result;
  }

  getLanguageValue(language: any) {
    let result = "";
    if (this.model && this.model[this.key]) {
      this.model[this.key].forEach((item: any) => {
        if (language == item.language) {
          result = item.value;
        }
      });
    }
    return result;
  }
}

export abstract class Field extends FieldType {
  constructor() {
    super();
  }
}
